import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Logo } from "@/components/brand/Logo";
import { NAV } from "@/lib/site";

const linkClass = ({ isActive }) =>
  `px-3 py-2 rounded-full text-[0.95rem] font-medium transition-colors ${isActive ? "bg-sage-light text-ink" : "text-ink-soft hover:text-ink hover:bg-cream-deep"}`;

export const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 border-b border-cream-deep bg-cream/90 backdrop-blur-md no-print">
      <div className="container-site flex h-20 items-center justify-between gap-4">
        <Link to="/" aria-label="Addiction & Us home" data-testid="header-logo-link"><Logo /></Link>
        <nav aria-label="Main" className="hidden lg:flex items-center gap-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.to === "/"} className={linkClass} data-testid={`nav-${n.id}`}>{n.label}</NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Link to="/support" className="btn-primary hidden sm:inline-flex !py-2.5 !min-h-[44px]" data-testid="header-find-support-btn">Find Support</Link>
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button className="lg:hidden inline-flex h-12 w-12 items-center justify-center rounded-full hover:bg-cream-deep" aria-label="Open menu" data-testid="mobile-menu-button">
                <Menu className="h-6 w-6" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-cream w-[85vw] max-w-sm">
              <SheetTitle className="sr-only">Menu</SheetTitle>
              <nav aria-label="Mobile" className="mt-10 flex flex-col gap-1">
                {NAV.map((n) => (
                  <NavLink key={n.to} to={n.to} end={n.to === "/"} onClick={() => setOpen(false)}
                    className={({ isActive }) => `rounded-2xl px-4 py-3 text-lg font-serif ${isActive ? "bg-sage-light" : "hover:bg-cream-deep"}`}
                    data-testid={`mobile-nav-${n.id}`}>{n.label}</NavLink>
                ))}
                <Link to="/support" onClick={() => setOpen(false)} className="btn-primary mt-4" data-testid="mobile-find-support-btn">Find Support</Link>
                <Link to="/urgent-help" onClick={() => setOpen(false)} className="btn-secondary mt-2" data-testid="mobile-urgent-help-btn">Urgent help</Link>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
